import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";
import api from "../lib/api";

export default function CookieConsent() {
    const [settings, setSettings] = useState(null);
    const [visible, setVisible] = useState(false);
    const location = useLocation();
    const isAdmin = location.pathname.startsWith("/sprava");

    useEffect(() => {
        if (isAdmin) return;
        const accepted = localStorage.getItem("sg_cookie_consent");
        if (accepted) return;

        api.get("/cookie-consent/settings").then(r => {
            const s = r.data;
            if (s?.enabled) {
                setSettings(s);
                setVisible(true);
            }
        }).catch(() => {});
    }, [isAdmin]);

    const handleAccept = () => {
        localStorage.setItem("sg_cookie_consent", "accepted");
        setVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem("sg_cookie_consent", "rejected");
        setVisible(false);
    };

    if (isAdmin || !visible || !settings) return null;

    const isPopup = settings.style === "popup" || settings.position === "center";

    if (isPopup) {
        return (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40" data-testid="cookie-consent-overlay">
                <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6" data-testid="cookie-consent-popup">
                    <div className="flex items-center gap-2 mb-3">
                        <Cookie size={20} className="text-green-600" />
                        <h3 className="text-lg font-bold text-gray-900">{settings.title}</h3>
                    </div>
                    <p className="text-sm text-gray-600 mb-4 leading-relaxed">{settings.text}</p>
                    {settings.privacy_policy_url && (
                        <a href={settings.privacy_policy_url} className="text-xs text-green-600 hover:underline mb-4 block">Zasady ochrany soukromi</a>
                    )}
                    <div className="flex gap-2">
                        <Button onClick={handleAccept} className="flex-1 bg-green-600 hover:bg-green-700 text-white" data-testid="cookie-accept-btn">
                            {settings.accept_button_text || "Souhlasim"}
                        </Button>
                        {settings.show_reject_button !== false && (
                            <Button variant="outline" onClick={handleReject} className="flex-1" data-testid="cookie-reject-btn">
                                {settings.reject_button_text || "Odmitnout"}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`fixed left-0 right-0 z-[9999] ${settings.position === "top" ? "top-0" : "bottom-0"}`} data-testid="cookie-consent-bar">
            <div className="bg-white border-t border-gray-200 shadow-lg px-4 py-3 sm:px-6">
                <div className="sg-container flex flex-col sm:flex-row items-center gap-3">
                    <div className="flex items-center gap-2 flex-1">
                        <Cookie size={16} className="text-green-600 flex-shrink-0" />
                        <p className="text-sm text-gray-700">{settings.text}</p>
                        {settings.privacy_policy_url && (
                            <a href={settings.privacy_policy_url} className="text-xs text-green-600 hover:underline flex-shrink-0">Vice info</a>
                        )}
                    </div>
                    <div className="flex items-center gap-2 flex-shrink-0">
                        <Button size="sm" onClick={handleAccept} className="bg-green-600 hover:bg-green-700 text-white text-xs px-4" data-testid="cookie-accept-btn">
                            {settings.accept_button_text || "Souhlasim"}
                        </Button>
                        {settings.show_reject_button !== false && (
                            <Button size="sm" variant="outline" onClick={handleReject} className="text-xs px-3" data-testid="cookie-reject-btn">
                                {settings.reject_button_text || "Odmitnout"}
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
